export default "__VITE_ASSET__D$ziQG9m__"